import { motion, AnimationControls } from 'framer-motion';

import styles from './VerticalBorder.module.css';

interface Props {
  control: AnimationControls;
}

export default function VerticalBorder({ control }: Props) {
  return <motion.span className={styles.border} animate={control} />;
}
